module.exports = require(45).default;
module.exports.default = module.exports;
